import React from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";

const PdfViewer = ({ pdfUrl }) => {
  const zoomPluginInstance = zoomPlugin();
  const toolbarPluginInstance = toolbarPlugin();
  const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;
  const { Toolbar } = toolbarPluginInstance;

  return (
    <div style={{ height: "750px", width: "80%", margin: "auto" }}>
      <Worker workerUrl={pdfjsWorker}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
          }}
        >
          <div
            style={{
              borderBottom: "1px solid rgba(0, 0, 0, 0.3)",
              padding: "0.25rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Toolbar>
              {(slots) => {
                const {
                  CurrentPageInput,
                  GoToNextPage,
                  GoToPreviousPage,
                  NumberOfPages,
                } = slots;
                return (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <ZoomOutButton />
                    <ZoomPopover />
                    <ZoomInButton />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "auto",
                      }}
                    >
                      <GoToPreviousPage />
                      <CurrentPageInput />
                      <GoToNextPage />
                      <NumberOfPages />
                    </div>
                  </div>
                );
              }}
            </Toolbar>
          </div>
          <div
            style={{
              flex: 1,
              overflow: "hidden",
            }}
          >
            <Viewer fileUrl={pdfUrl} plugins={[[zoomPluginInstance, toolbarPluginInstance]]} />
          </div>
        </div>
      </Worker>
    </div>
  );
};

export default PdfViewer;
